import { render, staticRenderFns } from "./JeecgOrderCustomerList.vue?vue&type=template&id=75072528&scoped=true&"
import script from "./JeecgOrderCustomerList.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./JeecgOrderCustomerList.vue?vue&type=style&index=0&id=75072528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75072528",
  null
  
)

export default component.exports